import { DeviceAPI } from "./DeviceAPI.js";
import { SessionHandler } from "./SessionHandler.js";

export class SensoterraMoistureSensorAPI extends DeviceAPI {
    /**
     * registers a sensoterra moisture sensor based on the provided parameters
     * @param {String} EnclosureID the SerialNumber on the probe
     * @param {String} lat
     * @param {String} long
     * @param {String} zone
     * @param {number} depth
     * @param {string} soilType
     * @param {String} label
     * @param {String} userId
     * @return {Promise<void>}
     */
    static async addOne(EnclosureID, lat, long, zone, depth, soilType, label) {
        let response = await SessionHandler.doFetch("sensoterra", {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            redirect: "follow",
            body: JSON.stringify({
                EnclosureID: EnclosureID,
                zone: zone,
                latitude: lat,
                longitude: long,
                label: label,
                depth: depth,
                soilType: soilType,
                // userId: userId,
            }),
        });
        if (response.ok) {
            return await response.json();
        } else {
            let json = await response.json();
            throw new Error({ ...json });
        }
    }

    /**
     * Deletes a single device based on it's id
     * @param devId
     * @return {Promise<boolean>}
     */
    static async deleteOne(devId) {
        await SessionHandler.doFetch("sensoterra/delete/" + devId, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "DELETE",
            redirect: "follow",
        });
        return true;
    }

    /**
     * Gets the information for a device with an enclosureID, deviceID, or PCB QR code corresponding
     * to query.
     * @param query
     * @return {Promise<{NodeId: String, QRs: {Enclosure: String, PCB: String}, DeviceDoc: Object, MicrovalveDoc: Object}>}
     */
    static async getOne(query) {
        let response = await SessionHandler.doFetch("devices/info/" + query, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "GET",
            redirect: "follow",
        });
        return await response.json();
    }

    /**
     * Updates a soil moisture probe
     * @param id {string}
     * @param args {{latitude: number, longitude: number, zone : string, name: string, depth: number}} new data to add to thing
     * @return {Promise<{NodeId: String, QRs: {Enclosure: String, PCB: String}, DeviceDoc: Object, MicrovalveDoc: Object}>}
     */
    static async editOne(id, args) {
        let response = await SessionHandler.doFetch("sensoterra/edit/" + id, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            redirect: "follow",
            body: JSON.stringify({
                ...args,
            }),
        });
        return await response.json();
    }
}
